import { useState } from "react";
import { Eye, EyeOff, Film, Lock, Mail } from "lucide-react";
import { Brand, Segmented, Surface } from "../components.jsx";
import { useAuth } from "../auth.jsx";

export default function AuthPage() {
  const { authenticate } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [visible, setVisible] = useState(false);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (mode === "register" && password !== confirm) return setError("Las contraseñas no coinciden.");
    setWorking(true); setError("");
    try { await authenticate({ email: email.trim().toLowerCase(), password, register: mode === "register" }); }
    catch (caught) { setError(caught.message); }
    finally { setWorking(false); }
  };

  return (
    <div className="auth-layout">
      <section className="auth-story">
        <Brand />
        <div className="auth-story-copy">
          <span className="auth-monogram">R</span>
          <h1>Tus películas,<br />con tu gente.</h1>
          <p>Guarda lo que ves, escribe reseñas y descubre qué están viendo tus amigos.</p>
        </div>
        <div className="film-door" aria-hidden="true"><span /><span /><span /></div>
      </section>
      <main className="auth-panel">
        <Surface as="form" className="auth-form" onSubmit={submit}>
          <div><h2>{mode === "login" ? "Vuelve a tu Rollo" : "Crea tu cuenta"}</h2><p>Correo y contraseña. Sin Google.</p></div>
          <Segmented ariaLabel="Modo de acceso" value={mode} onChange={setMode} options={[
            { value: "login", label: "Entrar" }, { value: "register", label: "Crear cuenta" }
          ]} />
          <label className="field"><Mail /><span>Correo</span><input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" required /></label>
          <label className="field"><Lock /><span>Contraseña</span><input type={visible ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete={mode === "register" ? "new-password" : "current-password"} minLength={10} required /><button type="button" onClick={() => setVisible(!visible)} aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}>{visible ? <EyeOff /> : <Eye />}</button></label>
          {mode === "register" ? <label className="field"><Lock /><span>Repite la contraseña</span><input type={visible ? "text" : "password"} value={confirm} onChange={(event) => setConfirm(event.target.value)} autoComplete="new-password" minLength={10} required /></label> : null}
          {error ? <p className="form-error">{error}</p> : null}
          <button className="primary-button" disabled={working}>{working ? "Un momento…" : mode === "login" ? "Entrar" : "Crear cuenta"}</button>
          <p className="form-note">Puedes mantener esta sesión abierta a la vez que la del iPhone y otros navegadores.</p>
        </Surface>
      </main>
    </div>
  );
}
